var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[(_vm.isIconfont)?_c('icon-font',_vm._g(_vm._b({},'icon-font',_vm.customAttrs,false),_vm.$listeners)):_c('a-icon',_vm._g(_vm._b({},'a-icon',_vm.customAttrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }